// Model.js
// -----------------------
// @module Case
define('BRAccessible.SS2Model', ['Backbone', 'Utils'], function (Backbone, Utils) {
	'use strict';

	// @class Case.Fields.Model @extends Backbone.Model
	return Backbone.Model.extend({
		//@property {String} urlRoot
		urlRoot: Utils.getAbsoluteUrl(
			getExtensionAssetsPath('Modules/BRAccessible/SuiteScript2/BRAccessible.Service.ss'),
			true
		)
	});
});
